import { FC } from "react";
import { ApplicantDetailsPage } from "../../components/pages/ApplicantDetailsPage";
import { ApplicantDetailsStepperPage } from "../../components/pages/ApplicantDetailsStepperPage";
import { ApplicantFormSuccessPage } from "../../components/pages/ApplicantFormSuccessPage";
import { CreateUserPage } from "../../components/pages/CreateUserPage";
import { DataPrivacyPage } from "../../components/pages/DataPrivacyPage";
import { FailedApplicantsPage } from "../../components/pages/FailedApplicantsPage";
import { FinalInterviewPage } from "../../components/pages/FinalInterviewPage";
import { ForgotPasswordPageContainer } from "../../components/pages/ForgotPasswordPage";
import { InitialInterviewPage } from "../../components/pages/InitialInterviewPage";
import JobOfferPageContainer from "../../components/pages/JobOfferPage/JobOfferPageContainer";
import { LoginPageContainer } from "../../components/pages/LoginPage";
import { NewApplicantsPage } from "../../components/pages/NewApplicantsPage";
import { PageNotFoundPage } from "../../components/pages/PageNotFoundPage";
import { PersonalDetailsPage } from "../../components/pages/PersonalDetailsPage";
import { ResetPasswordPage } from "../../components/pages/ResetPasswordPage";
import ScouterTestPageContainer from "../../components/pages/ScouterTestPage/ScouterTestPageContainer";
import { ShortlistedPage } from "../../components/pages/ShortlistedPage";
import { TestdomeExamPage } from "../../components/pages/TestdomeExamPage";
import { UsersPage } from "../../components/pages/UsersPage";
import { PositionsPage } from "../../components/pages/PositionsPage";
import { UpdateUserPageContainer } from "../../components/pages/UpdateUserPage";
import { SearchApplicantPage } from "../../components/pages/SearchApplicantPage";
import { CreatePositionPage } from "../../components/pages/CreatePositionPage";
import { UpdatePositionPageContainer } from "../../components/pages/UpdatePositionPage";
import InsightsPage from "./../../components/pages/InsightsPage/InsightsPage";
import { ApplicantsDatabasePage } from "../../components/pages/ApplicantsDatabase";
import { MySchedulePage } from "../../components/pages/MySchedulePage";
import { NotificationPage } from "../../components/pages/NotificationPage";

type routesWithRedirectType = {
  path: string;
  to: string;
}[];

type routesType = {
  path: string;
  component: FC;
}[];

const routesWithRedirect: routesWithRedirectType = [
  {
    path: "/careers",
    to: "/careers/data-privacy",
  },
];

const subAuthRoutes = [
  {
    path: "/careers/details",
    component: ApplicantDetailsStepperPage,
  },
  {
    path: "/careers/data-privacy",
    component: DataPrivacyPage,
  },
  {
    path: "/careers/success",
    component: ApplicantFormSuccessPage,
  },
];

const routes: routesType = [
  {
    path: "/login",
    component: LoginPageContainer,
  },
  {
    path: "/forgot-password",
    component: ForgotPasswordPageContainer,
  },
  {
    path: "/reset-password/action",
    component: ResetPasswordPage,
  },
];

const privateRoutes: routesType = [
  {
    path: "/recruit/new-applicants",
    component: NewApplicantsPage,
  },
  {
    path: "/recruit/new-applicants/:id/:fromSearch?",
    component: ApplicantDetailsPage,
  },
  {
    path: "/recruit/shortlisted",
    component: ShortlistedPage,
  },
  {
    path: "/recruit/shortlisted/:id/:fromSearch?",
    component: ApplicantDetailsPage,
  },
  {
    path: "/recruit/technical-exam",
    component: TestdomeExamPage,
  },
  {
    path: "/recruit/technical-exam/:id/:fromSearch?",
    component: ApplicantDetailsPage,
  },
  {
    path: "/recruit/initial-interview",
    component: InitialInterviewPage,
  },
  {
    path: "/recruit/initial-interview/:id/:fromSearch?",
    component: ApplicantDetailsPage,
  },
  {
    path: "/recruit/psychological-exam",
    component: ScouterTestPageContainer,
  },
  {
    path: "/recruit/psychological-exam/:id/:fromSearch?",
    component: ApplicantDetailsPage,
  },
  {
    path: "/recruit/final-interview",
    component: FinalInterviewPage,
  },
  {
    path: "/recruit/final-interview/:id/:fromSearch?",
    component: ApplicantDetailsPage,
  },
  {
    path: "/recruit/job-offer",
    component: JobOfferPageContainer,
  },
  {
    path: "/recruit/job-offer/:id/:fromSearch?",
    component: ApplicantDetailsPage,
  },
  {
    path: "/recruit/my-account",
    component: PersonalDetailsPage,
  },
  { path: "/recruit/failed", component: FailedApplicantsPage },
  {
    path: "/recruit/failed/:id/:fromSearch?",
    component: ApplicantDetailsPage,
  },
  {
    path: "/admin/users/create",
    component: CreateUserPage,
  },
  { path: "/admin/users", component: UsersPage },
  {
    path: "/admin/users/:id",
    component: UpdateUserPageContainer,
  },
  {
    path: "/admin/positions",
    component: PositionsPage,
  },
  {
    path: "/admin/positions/create",
    component: CreatePositionPage,
  },
  {
    path: "/admin/positions/:id",
    component: UpdatePositionPageContainer,
  },
  {
    path: "/recruit/search-applicants",
    component: SearchApplicantPage,
  },
  {
    path: "/recruit/insights",
    component: InsightsPage,
  },
  {
    path: "/recruit/applicants-database",
    component: ApplicantsDatabasePage,
  },
  {
    path: "/recruit/my-schedule",
    component: MySchedulePage,
  },
  {
    path: "/admin/notifications",
    component: NotificationPage,
  },
  { path: "*", component: PageNotFoundPage },
];

export { routesWithRedirect, routes, privateRoutes, subAuthRoutes };
